import { useState } from "react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface LobbyProps {
  onJoin: (nickname: string, roomCode: string) => void;
}

export function Lobby({ onJoin }: LobbyProps) {
  const [nickname, setNickname] = useState("");
  const [roomCode, setRoomCode] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (nickname && roomCode) {
      onJoin(nickname, roomCode.toUpperCase());
    }
  };

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <Card className="w-full max-w-md euro-glass border-white/20">
        <CardHeader>
          <CardTitle>Join Eurovizion Room</CardTitle>
          <CardDescription>Enter your nickname and the room code to start.</CardDescription>
        </CardHeader>
        <form onSubmit={handleSubmit}>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="nickname">Nickname</Label>
              <Input
                id="nickname"
                placeholder="Enter your nickname"
                value={nickname}
                onChange={(e) => setNickname(e.target.value)}
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="roomCode">Room Code</Label>
              <Input
                id="roomCode"
                placeholder="Enter 4-letter code"
                value={roomCode}
                onChange={(e) => setRoomCode(e.target.value)}
                required
                maxLength={4}
                className="uppercase font-mono"
              />
            </div>
          </CardContent>
          <CardFooter>
            <Button type="submit" className="w-full euro-glow font-bold uppercase tracking-wider">Join Room</Button>
          </CardFooter>
        </form>
      </Card>
    </div>
  );
}
